// 公司信息模拟数据
export default {
  name: 'Dongguan Caicheng Printing Factory',
  shortName: 'PACKCCP',
  established: 2003,
  years: 21,
  location: 'Guangdong, China',
  type: 'Custom Manufacturer',
  certification: 'Verified by SGS Group',
  industryYears: 18,
  mainProducts: ['Paper Box', 'Gift Box', 'Paper Bag', 'Paper Card', 'Catalogue'],
  trustBadges: [
    'OEM for well-known brands',
    'Supplier for Fortune 500 companies',
    'Quality management certified'
  ],
  description: 'Dongguan Caicheng Printing Factory was established in 2003, located in Dongguan City, Guangdong Province, China. We are a professional manufacturer specializing in various packaging products, including paper boxes, gift boxes, paper bags, paper cards, and catalogues.',
  highlights: [
    { label: 'Factory Area', value: '10,000+ sqm' },
    { label: 'Employees', value: '200+' },
    { label: 'Annual Revenue', value: '$10M+' },
    { label: 'Export Markets', value: '50+ countries' }
  ],
  certifications: [
    { name: 'ISO 9001:2015', description: 'Quality Management System' },
    { name: 'FSC', description: 'Forest Stewardship Council Certified' },
    { name: 'SGS', description: 'SGS Verified Manufacturer' },
    { name: 'BSCI', description: 'Business Social Compliance Initiative' }
  ],
  contact: {
    email: 'info@caihui-printing.com',
    phone: '+86-769-8888-8888',
    fax: '+86-769-8888-8889',
    address: 'No.88, Industrial Road, Dongguan City, Guangdong Province, China',
    website: 'www.caihui-printing.com'
  },
  video: {
    poster: 'https://via.placeholder.com/800x450/1a3a2a/ffffff?text=Factory+Video',
    url: ''
  }
}
